import React, {
  useEffect,
  useState,
} from 'react';
import { node } from 'prop-types';
import { ABContext } from '../../contexts/ABContext';
import isABTest from '../../ab/isabtest';

export const ABContextProvider = ({ children }) => {
  const [abTests, setABTests] = useState({});

  useEffect(() => {
    const HOT616IsVariant = isABTest('HOT-616-dlp-hotels-tickets-redesign-v2');

    // Add context
    const testHOT616 = ({
      HOT616: {
        name: 'HOT-616-dlp-hotels-tickets-redesign-v2',
        variant: HOT616IsVariant,
      },
    });

    // Update state
    setABTests((prevState) => ({ ...prevState, ...testHOT616 }));
  }, []);

  return (
    <ABContext.Provider value={abTests}>{ children }</ABContext.Provider>
  );

  // CRO-000-test = example cro test
  // useEffect(() => {
  //   const CRO000IsVariant = isABTest('CRO-000-test-name');

  //   // Add context
  //   const testCRO000 = ({
  //     CRO000: {
  //       name: 'CRO-000-test-name',
  //       variant: CRO000IsVariant,
  //     },
  //   });

  //   // Update state
  //   setABTests((prevState) => ({ ...prevState, ...testCRO000 }));
  // }, []);

  // return (
  //   <ABContext.Provider value={abTests}>{ children }</ABContext.Provider>
  // );
  // End CRO-000-test = example cro test
};

ABContextProvider.propTypes = {
  children: node.isRequired,
};

ABContextProvider.defaultProps = {};

export default ABContextProvider;
